"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetBonuses = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const slice_1 = require("./slice");
const selectors_1 = require("./selectors");
const useGetBonuses = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    (0, react_1.useEffect)(() => {
        if (accountId) {
            dispatch(slice_1.accountProviderActions.fetchBonuses());
        }
    }, [dispatch, accountId]);
};
exports.useGetBonuses = useGetBonuses;
//# sourceMappingURL=hooks.js.map